/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_AvoidPreferencesOptions_ } from "../models/DataMessageResponse_AvoidPreferencesOptions_";
import type { DataMessageResponse_Dict_str__Any__ } from "../models/DataMessageResponse_Dict_str__Any__";
import type { DataMessageResponse_List_str__ } from "../models/DataMessageResponse_List_str__";
import type { DataMessageResponse_MealPreferencesOptions_ } from "../models/DataMessageResponse_MealPreferencesOptions_";
import type { DataMessageResponse_str_ } from "../models/DataMessageResponse_str_";
import type { GeneralsMealPreferencesAvoid } from "../models/GeneralsMealPreferencesAvoid";
import type { GeneralsMealPreferencesMealType } from "../models/GeneralsMealPreferencesMealType";
import type { GeneralsMealPreferencesProteinSources } from "../models/GeneralsMealPreferencesProteinSources";
import type { MealPreferences } from "../models/MealPreferences";
import type { MealTime } from "../models/MealTime";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class MealPreferencesService {
  /**
   * Update General Meal Preferences Avoids
   * Updates general meal preferences for items the user avoids.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_List_str__ Successful Response
   * @throws ApiError
   */
  public static updateGeneralMealPreferencesAvoidsApiV1MealPreferencesGeneralAvoidsPut(
    xUserId: string,
    requestBody: GeneralsMealPreferencesAvoid,
  ): CancelablePromise<DataMessageResponse_List_str__> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/meal-preferences/general/avoids",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get General Meal Preferences Avoids
   * Retrieves general meal preferences for items the user avoids.
   * @param xUserId
   * @returns DataMessageResponse_List_str__ Successful Response
   * @throws ApiError
   */
  public static getGeneralMealPreferencesAvoidsApiV1MealPreferencesGeneralAvoidsGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_List_str__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/general/avoids",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update General Meal Preferences Protein Sources
   * Updates general meal preferences for favourite protein sources.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_List_str__ Successful Response
   * @throws ApiError
   */
  public static updateGeneralMealPreferencesProteinSourcesApiV1MealPreferencesProteinSourcesPut(
    xUserId: string,
    requestBody: GeneralsMealPreferencesProteinSources,
  ): CancelablePromise<DataMessageResponse_List_str__> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/meal-preferences/protein-sources",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update General Meal Type Preference
   * Updates general meal type preference (quickAndEasy, cookFromScratch, or both).
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_str_ Successful Response
   * @throws ApiError
   */
  public static updateGeneralMealTypePreferenceApiV1MealPreferencesGeneralMealTypePreferencePut(
    xUserId: string,
    requestBody: GeneralsMealPreferencesMealType,
  ): CancelablePromise<DataMessageResponse_str_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/meal-preferences/general/meal-type-preference",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get General Meal Type Preference
   * Retrieves general meal type preference (quickAndEasy, cookFromScratch, or both).
   * Returns 404 if the preference has not been set yet.
   * @param xUserId
   * @returns DataMessageResponse_str_ Successful Response
   * @throws ApiError
   */
  public static getGeneralMealTypePreferenceApiV1MealPreferencesGeneralMealTypePreferenceGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_str_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/general/meal-type-preference",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Avoid Preference Options
   * Get available avoid preference options.
   * @returns DataMessageResponse_AvoidPreferencesOptions_ Successful Response
   * @throws ApiError
   */
  public static getAvoidPreferenceOptionsApiV1MealPreferencesAvoidsOptionsGet(): CancelablePromise<DataMessageResponse_AvoidPreferencesOptions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/avoids/options",
    });
  }
  /**
   * Update Meal Preferences
   * Updates the meal preferences for a user.
   * @param mealTime
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static updateMealPreferencesApiV1MealPreferencesMealTimePut(
    mealTime: MealTime,
    xUserId: string,
    requestBody: MealPreferences,
  ): CancelablePromise<DataMessageResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/meal-preferences/{meal_time}",
      path: {
        meal_time: mealTime,
      },
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Meal Preferences
   * Get the meal preferences of a user.
   * @param mealTime
   * @param xUserId
   * @returns DataMessageResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static getMealPreferencesApiV1MealPreferencesMealTimeGet(
    mealTime: MealTime,
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/{meal_time}",
      path: {
        meal_time: mealTime,
      },
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Meal Preference Options
   * Get available meal preference options for a given meal time.
   * @param mealTime
   * @returns DataMessageResponse_MealPreferencesOptions_ Successful Response
   * @throws ApiError
   */
  public static getMealPreferenceOptionsApiV1MealPreferencesMealTimeOptionsGet(
    mealTime: MealTime,
  ): CancelablePromise<DataMessageResponse_MealPreferencesOptions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/{meal_time}/options",
      path: {
        meal_time: mealTime,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Meal Preferences By Admin
   * Get the meal preferences for a user by an admin.
   * @param mealTime
   * @param userId
   * @returns DataMessageResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static getMealPreferencesByAdminApiV1MealPreferencesMealTimeUserIdGet(
    mealTime: MealTime,
    userId: string,
  ): CancelablePromise<DataMessageResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences/{meal_time}/{user_id}",
      path: {
        meal_time: mealTime,
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get All Meal Preferences
   * Get the meal preferences for a user by an admin.
   * @param xUserId
   * @returns DataMessageResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static getAllMealPreferencesApiV1MealPreferencesGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meal-preferences",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
